// Libs
import { useEffect, useState } from "react";
import { FaMoneyBill } from "react-icons/fa";
import { useQuery } from "@tanstack/react-query";
// Components
import KPI from "./KPI";
import Charts from "./Charts";
// Types
import { DashboardKpis } from "../../Libs/Types/Dashboard";
import {
  GetKpiAPI_Response,
  SuccessResponseWrapper,
} from "../../Libs/Types/API-Responses";
// Endpoints
import { apiGetMetrics } from "../../Endpoints/Metrics";

export default function Dashboard() {
  const [kpi, setKpi] = useState<DashboardKpis[]>([]);

  // Fetching Metrics
  const { data: getMetricsData, isSuccess: isKpiFetch } = useQuery({
    queryKey: ["/get-kpi"],
    queryFn: apiGetMetrics,
    retry: 0,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (isKpiFetch) {
      const getAPIData: SuccessResponseWrapper<GetKpiAPI_Response> =
        getMetricsData?.data;
      setKpi([
        {
          name: "Total Claims",
          value: getAPIData?.data?.total_claims,
          icon: <FaMoneyBill size={20} className="text-icon-secondary" />,
        },
        {
          name: "Approved Amount",
          value: getAPIData?.data?.approved_amount,
          icon: <FaMoneyBill size={20} className="text-icon-secondary" />,
        },
        {
          name: "Approved Claims",
          value: getAPIData?.data?.approved_claims,
          icon: <FaMoneyBill size={20} className="text-icon-secondary" />,
        },
        {
          name: "Denied Claims",
          value: getAPIData?.data?.denied_claims,
          icon: <FaMoneyBill size={20} className="text-icon-secondary" />,
        },
        {
          name: "Total Amount",
          value: getAPIData?.data?.total_amount,
          icon: <FaMoneyBill size={20} className="text-icon-secondary" />,
        },
      ]);
    }
    // eslint-disable-next-line
  }, [getMetricsData]);
  return (
    <>
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-2 mb-2">
        {kpi.map((listValue, key) => {
          return (
            <KPI
              key={listValue["name"] + key}
              name={listValue["name"]}
              value={listValue["value"]}
              icon={listValue["icon"]}
            />
          );
        })}
      </div>
      <Charts />
    </>
  );
}
